import { type FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "../../contexts/analytics/hooks";
import type { NurseInShift } from "../../utils/models";
import { SystemSideDrawer } from "../UIToolkit/Panels/SystemSideDrawer";
import { ShiftHistoryContent } from "./ShiftHistoryContent";
import { SHIFT_HISTORY_TEST_ID } from "./shiftHistoryDisplay";

type Props = {
	open: boolean;
	onClose: () => void;
	nurseInShift: NurseInShift;
	nurseName: string;
	/** Opens the recurring shift editor; undefined for a non-recurring shift or a locked Master Schedule. */
	onEditRecurring: (() => void) | undefined;
	surface: string;
};

export const ShiftHistoryDrawer: FC<Props> = ({ open, onClose, nurseInShift, nurseName, onEditRecurring, surface }) => {
	const { t } = useTranslation();
	const { track } = useAnalytics();
	useEffect(() => {
		if (open) track("shift_history_opened", { shift_id: nurseInShift.id, surface });
	}, [open, nurseInShift.id, surface, track]);

	return (
		<SystemSideDrawer
			open={open}
			onClose={onClose}
			dialogLabel={t("shiftHistory.eyebrow")}
			hideHeader
			bodySx={{ p: 0, overscrollBehavior: "contain" }}
			dataTestId={`${SHIFT_HISTORY_TEST_ID}-drawer`}
		>
			{open && (
				<ShiftHistoryContent key={nurseInShift.id} nurseInShift={nurseInShift} nurseName={nurseName} onClose={onClose} onEditRecurring={onEditRecurring} />
			)}
		</SystemSideDrawer>
	);
};
